// Mirrors aceb-api user-facing cashback response. CREDITED rows ride the
// balance ledger via BalanceLedgerType.CASHBACK; this type covers PENDING
// rows surfaced on /account/balance under "Upcoming cashbacks".

export enum CashbackStatus {
  PENDING = 'PENDING',
  CREDITED = 'CREDITED',
  CANCELED = 'CANCELED',
}

export enum CashbackRuleType {
  LIFETIME_TOTAL = 'lifetime_total',
  PER_ORDER = 'per_order',
}

// GET /user/cashback/program. Only enabled rules are returned.
export interface PublicCashbackRule {
  ruleType: CashbackRuleType;
  label: string;
  minLifetimeEurCents?: number;
  minOrderEurCents?: number;
  ratePercent: number;
}

export interface CashbackProgram {
  maturityDays: number;
  rules: PublicCashbackRule[];
}

export interface CashbackEntry {
  _id: string;
  userId: string;
  orderId: string;
  baseEurCents: number;
  fxRateUsed: number;
  ratePercent: number;
  amountCents: number;
  status: CashbackStatus;
  maturityDate: string;
  creditedLedgerId?: string;
  createdAt: string;
}
